import { meetingRoomBookingService } from "@/services/api/meetingRoomBooking.service";
import { meetingRoomBookingModel } from "@/models/api/meetingRoomBooking.model";
import { sharedHelper, alertHelper } from "@/utils";
import i18n from "@/i18n";

export const MEETING_ROOM_BOOKING_MODULE = "api/meetingRoomBooking";
export const GET_ALL_MEETING_ROOM_BOOKING = "getAllMeetingRoomBooking";
export const GET_MEETING_ROOM_BOOKING = "getMeetingRoomBooking";
const pagination = () => ({
  pageNumber: 1,
  pageSize: 15,
  lastPage: 1,
  tableRowsCounts: 0,
  total: 0,
});
export const state = {
  list: { data: [], pagination: pagination() },
  details: {},
  status: { list: true, detail: true },
};
const fail = (commit, error) => {
  commit("failure");
  alertHelper.alertError({
    message: sharedHelper.getErrorMessage(error),
    title: i18n.t("message.error"),
  });
};

export const actions = {
  async [GET_ALL_MEETING_ROOM_BOOKING]({ commit }, { filter }) {
    commit("requesting", "list");
    try {
      const result = await meetingRoomBookingService.getAll(filter);
      commit("listSuccess", result);
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
  async [GET_MEETING_ROOM_BOOKING]({ commit }, { uuid }) {
    commit("requesting", "detail");
    try {
      const result = await meetingRoomBookingService.show(uuid);
      commit("detailSuccess", result);
      return result;
    } catch (error) {
      fail(commit, error);
      return null;
    }
  },
};
export const mutations = {
  requesting(state, type) {
    state.status[type] = false;
  },
  listSuccess(state, result) {
    const rows = Array.isArray(result?.data)
      ? result.data
      : result?.data
      ? [result.data]
      : [];
    state.list.data = rows.map(meetingRoomBookingModel);
    state.list.pagination = result?.pagination
      ? sharedHelper.apiPaginationAdapter(result.pagination)
      : { ...pagination(), total: rows.length, tableRowsCounts: rows.length };
    state.status.list = true;
  },
  detailSuccess(state, result) {
    state.details = meetingRoomBookingModel(result?.data || result || {});
    state.status.detail = true;
  },
  failure(state) {
    state.status = { list: true, detail: true };
  },
};
